import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { ADD_EVENT } from "src/constants/mutations";
import { failureToast, successToast } from "src/utils/toasts";
import { AddEventInput } from "src/interfaces/event.interface";
import { add_event } from "src/store/features/events-slice";

export const useAddEvent = () => {
  const dispatch = useDispatch();
  const { axBe } = useAxiosInterceptor();
  
  const [isAddingEvent, setIsAddingEvent] = useState(false);

  const addEventMutation = useCallback(
    async (addEventInput: AddEventInput): Promise<boolean> => {
      setIsAddingEvent(true);

      try {
        const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
          query: ADD_EVENT,
          variables: {
            addEventInput,
          },
        });

        if (data?.errors && data.errors.length > 0) {
          const errorMessage = data.errors[0]?.message || "Failed to add event";
          console.error("GraphQL error:", errorMessage);
          failureToast(errorMessage);
          return false;
        }

        if (data?.data?.addEvent) {
          dispatch(add_event(data.data.addEvent));
          successToast("Event has been added successfully!");
          return true;
        }
        console.error("No event data returned from mutation");
        failureToast("Failed to add event: No data returned");
        return false;
      } catch (err: any) {
        console.error("Error adding event:", err);
        const errorMessage = err?.response?.data?.errors?.[0]?.message || err?.message || "Failed to add event";
        failureToast(errorMessage);
        return false;
      } finally {
        setIsAddingEvent(false);
      }
    },
    [axBe, dispatch]
  );

  return {
    isAddingEvent,
    addEvent: addEventMutation,
  };
};

